const Flickity = themeVendor.Flickity;

function lookbook() {
    const lookbookCollectionButtons = document.querySelectorAll('.lookbook-collections button'),
        lookbookView = document.querySelectorAll('.lookbook-view button'),
        lookbookProductWrappers = document.querySelectorAll('.lookbook-product-wrapper'),
        lookbookInnerProductWrappers = document.querySelectorAll('.inner-lookbook-collection-wrapper'),
        urlParams = new URLSearchParams(window.location.search),
        collectionName = urlParams.get('collection');

    if (collectionName) {
        
        const button = document.querySelector(`.lookbook-collections a[data-collection-name="${collectionName}"]`);
        const collectionWrappers = document.querySelectorAll('.lookbook-collection-wrapper');

        if (button && document.activeElement === button) {
            lookbookCollectionButtons.forEach(btn => {
            btn.classList.remove('active');
            });

            collectionWrappers.forEach(wrapper => {
            wrapper.classList.remove('active');
            });

            button.classList.add('active');
            document.querySelector('.lookbook-collection-wrapper[data-collection="'+ collectionName +'"]').classList.add('active');
        }
    }

    // Add event listeners to the buttons
    for (let button of lookbookCollectionButtons) {
        button.addEventListener('click', function() {
            const collectionName = button.getAttribute('data-collection-name');
            const collectionWrappers = document.querySelectorAll('.lookbook-collection-wrapper');

            lookbookCollectionButtons.forEach(btn => {
                btn.classList.remove('active');
            });

            collectionWrappers.forEach(wrapper => {
                wrapper.classList.remove('active');
            });

            this.classList.add('active');
            document.querySelector('.lookbook-collection-wrapper[data-collection="'+ collectionName +'"]').classList.add('active');

            // Update the URL parameter
            const url = new URL(window.location);
            url.searchParams.set('collection', collectionName);
            window.history.pushState({}, '', url);
        });
    }   

    for (let button of lookbookView) {
        button.addEventListener('click', function() {
            const viewName = button.getAttribute('data-view');

            lookbookView.forEach(btn => {
                btn.classList.remove('active');
            });

            this.classList.add('active');

            lookbookInnerProductWrappers.forEach(view => {
                view.setAttribute('data-grid', viewName);
            });
        });
    }

    for (let product of lookbookProductWrappers) {
        const productToggle = product.querySelector('.lookbook-product');
        productToggle.addEventListener('click', function() {
            function updateLookbookContentPadding() {
                const lookbookContent = document.querySelector('.lookbook-content');
                if (!lookbookContent) return;
                const anyActive = Array.from(document.querySelectorAll('.lookbook-product-slide')).some(slide => slide.classList.contains('active'));
                if (anyActive) {
                    lookbookContent.style.paddingLeft = '30px';
                    lookbookContent.style.paddingRight = '30px';
                } else {
                    lookbookContent.style.paddingLeft = '';
                    lookbookContent.style.paddingRight = '';
                }
            }
            updateLookbookContentPadding();

            document.querySelectorAll('.lookbook-product-slide').forEach(slide => {
                new MutationObserver(() => {
                    updateLookbookContentPadding();
                }).observe(slide, { attributes: true, attributeFilter: ['class'] });
            });
            
            const productID = productToggle.getAttribute('data-button');
            const productSlides = document.querySelectorAll('.lookbook-product-slide');

            productSlides.forEach(slide => {
            slide.classList.remove('active');
            });

            lookbookInnerProductWrappers.forEach(wrapper => {
            wrapper.classList.add('hidden');
            });

            if (window.scrollY > 0) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            }

            document.querySelector('.lookbook-product-slide[data-slide="'+ productID +'"]').classList.add('active');

            const carousels = document.querySelectorAll('.lookbook-product-slide[data-slide="'+ productID +'"] .lookbook-carousel');

            function initializeFlickity(carousel) {
            const flickityItems = carousel.getAttribute('data-flickity-items');
            let parsedOptions = {};
            if (flickityItems) {
                try {
                parsedOptions = JSON.parse(flickityItems);
                } catch (error) {
                console.error('Error parsing Flickity options:', error);
                }
            }

            if (carousel.flickityInstance) {
                carousel.flickityInstance.destroy();
            }

            carousel.flickityInstance = new Flickity(carousel, parsedOptions);
            }
            
            carousels.forEach(carousel => initializeFlickity(carousel));
            
            const allSlides = document.querySelectorAll('.lookbook-product-slide');
            allSlides.forEach(slide => {
                new MutationObserver((mutationsList) => {
                    mutationsList.forEach(mutation => {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            if (slide.classList.contains('active')) {
                                const slideCarousels = slide.querySelectorAll('.lookbook-carousel');
                                slideCarousels.forEach(carousel => initializeFlickity(carousel));
                            }
                        }
                    });
                }).observe(slide, { attributes: true, attributeFilter: ['class'] });
            });
            window.addEventListener('resize', () => {
                carousels.forEach(carousel => {
                    if (carousel.flickityInstance) {
                    carousel.flickityInstance.destroy();
                    }
                    initializeFlickity(carousel);
                });
            });
        });
    }

}

document.addEventListener("DOMContentLoaded", function() {
    lookbook();

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    const collectionWrappers = document.querySelectorAll('.lookbook-collection-wrapper');
    collectionWrappers.forEach(function(wrapper) {
        const productWrapper = wrapper.querySelector('.inner-collection-wrapper'),
              countdownWrapper = wrapper.querySelector('.inner-collection-countdown'),
              countdown = wrapper.querySelector('countdown-timer');

        if (typeof(countdown) != 'undefined' && countdown != null) {
            const endDate = new Date(countdown.getAttribute('data-date')).getTime();

            if (isNaN(endDate)) {
                countdown.textContent = 'Invalid date';
                return;
            }
    
            function updateCountdown() {
                const now = new Date().getTime();
                const distance = endDate - now;
            
                if (distance < 0) {
                    countdown.textContent = 'Countdown finished';
                    clearInterval(interval);
            
                    productWrapper.classList.remove('hidden');
                    countdownWrapper.classList.add('hidden');
            
                    return;
                }
            
                const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
            
                countdown.textContent = `${days}:${hours}:${minutes}:${seconds}`;
            }
            
    
            const interval = setInterval(updateCountdown, 1000);
            updateCountdown();
        }
    });
});


function updatePrevButtonState() {
    const activeWrapper = document.querySelector('.lookbook-collection-wrapper.active');
    const prevButton = document.querySelector('.lookbook-prev');
    if (!activeWrapper || !prevButton) return;
    const index = parseInt(activeWrapper.getAttribute('data-index'), 10);
    if (index === 0) {
        prevButton.classList.add('disabled');
    } else {
        prevButton.classList.remove('disabled');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    updatePrevButtonState();

    document.querySelectorAll('button.lookbook-collection').forEach(btn => {
        btn.addEventListener('click', () => {
            
            document.querySelectorAll('button.lookbook-collection').forEach(b => b.classList.remove('active'));
            
            btn.classList.add('active');

            const collectionName = btn.getAttribute('data-collection-name');
            
            document.querySelectorAll('.lookbook-collection-wrapper').forEach(wrapper => {
                wrapper.classList.remove('active');
            });
            
            const targetWrapper = document.querySelector(`.lookbook-collection-wrapper[data-collection="${collectionName}"]`);
            if (targetWrapper) {
                targetWrapper.classList.add('active');
            }

            const url = new URL(window.location);
            url.searchParams.set('collection', collectionName);
            window.history.pushState({}, '', url);

            window.scrollTo({ top: 0, behavior: 'smooth' });

            setTimeout(updatePrevButtonState, 10);
        });
    });

    const lookbookBack = document.querySelector('.lookbook-back');
    const lookbookInnerProductWrappers = document.querySelectorAll('.inner-lookbook-collection-wrapper');
    if (lookbookBack) {
        lookbookBack.addEventListener('click', function() {
            const productSlides = document.querySelectorAll('.lookbook-product-slide');
            productSlides.forEach(slide => {
                slide.classList.remove('active');
            });

            lookbookInnerProductWrappers.forEach(wrapper => {
                wrapper.classList.remove('hidden');
            });

            const lookbookContent = document.querySelector('.lookbook-content');
            const lookbookHeader = document.querySelector('.lookbook-header');
            if (lookbookContent) {
                lookbookContent.style.display = 'none';
            }
            if (lookbookHeader) {
                lookbookHeader.style.display = 'flex';
            }
        });
    }

    function updateLookbookTitle() {
        const activeWrapper = document.querySelector('.lookbook-collection-wrapper.active');
        const lookbookTitle = document.querySelector('.lookbook-title h5');
        if (activeWrapper && lookbookTitle) {
            const collectionName = activeWrapper.getAttribute('data-collection');
            if (collectionName) {
                const formattedName = collectionName
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, c => c.toUpperCase());
                lookbookTitle.textContent = formattedName;
            } else {
                lookbookTitle.textContent = '';
            }
        }
    }

    updateLookbookTitle();

    const observer = new MutationObserver(() => {
        updateLookbookTitle();
    });
    document.querySelectorAll('.lookbook-collection-wrapper').forEach(wrapper => {
        observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });

    document.querySelector('.lookbook-next')?.addEventListener('click', function() {
        const wrappers = Array.from(document.querySelectorAll('.lookbook-collection-wrapper'));
        const buttons = Array.from(document.querySelectorAll('.lookbook-collections button'));
        const activeIndex = wrappers.findIndex(wrapper => wrapper.classList.contains('active'));
        if (activeIndex !== -1 && activeIndex < wrappers.length - 1) {
            wrappers[activeIndex].classList.remove('active');
            wrappers[activeIndex + 1].classList.add('active');
            
            const innerWrapper = wrappers[activeIndex + 1].querySelector('.inner-lookbook-collection-wrapper');
            if (innerWrapper) {
                innerWrapper.classList.remove('hidden');
            }

            const nextCollectionName = wrappers[activeIndex + 1].getAttribute('data-collection');
            buttons.forEach(btn => {
                btn.classList.toggle('active', btn.getAttribute('data-collection-name') === nextCollectionName);
            });
            
            const url = new URL(window.location);
            url.searchParams.set('collection', nextCollectionName);
            window.history.pushState({}, '', url);
        }
        updatePrevButtonState();
    });

    document.querySelector('.lookbook-prev')?.addEventListener('click', function() {
        const wrappers = Array.from(document.querySelectorAll('.lookbook-collection-wrapper'));
        const buttons = Array.from(document.querySelectorAll('.lookbook-collections button'));
        const activeIndex = wrappers.findIndex(wrapper => wrapper.classList.contains('active'));
        if (activeIndex > 0) {
            wrappers[activeIndex].classList.remove('active');
            wrappers[activeIndex - 1].classList.add('active');
            
            const innerWrapper = wrappers[activeIndex - 1].querySelector('.inner-lookbook-collection-wrapper');
            if (innerWrapper) {
                innerWrapper.classList.remove('hidden');
            }

            const prevCollectionName = wrappers[activeIndex - 1].getAttribute('data-collection');
            buttons.forEach(btn => {
                btn.classList.toggle('active', btn.getAttribute('data-collection-name') === prevCollectionName);
            });
            
            const url = new URL(window.location);
            url.searchParams.set('collection', prevCollectionName);
            window.history.pushState({}, '', url);
        }
        updatePrevButtonState();
    });

    function updateLookbookTabsVisibility() {
        const productSlides = document.querySelectorAll('.lookbook-product-slide');
        const lookbookTabs = document.querySelector('.lookbook-tabs');
        if (!lookbookTabs) return;
        const anyActive = Array.from(productSlides).some(slide => slide.classList.contains('active'));
        lookbookTabs.style.display = anyActive ? 'none' : '';
    }

    updateLookbookTabsVisibility();

    const productSlides = document.querySelectorAll('.lookbook-product-slide');
    productSlides.forEach(slide => {
        new MutationObserver(() => {
            updateLookbookTabsVisibility();
        }).observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    const viewLooksButtons = document.querySelectorAll('button.view-looks');
    viewLooksButtons.forEach(button => {
        button.addEventListener('click', function() {
            const productSlide = button.closest('.lookbook-product-slide');
            if (productSlide) {
                productSlide.classList.remove('active');
                let sibling = productSlide.parentElement.querySelector('.inner-lookbook-collection-wrapper');
                if (sibling) {
                    sibling.classList.remove('hidden');
                }
            }
        });
    });

    const nextLookButtons = document.querySelectorAll('button.next-look');
    nextLookButtons.forEach(button => {
        button.addEventListener('click', function() {
            const currentSlide = button.closest('.lookbook-product-slide');
            if (!currentSlide) return;
            currentSlide.classList.remove('active');
            let nextSlide = currentSlide.nextElementSibling;
            while (nextSlide && !nextSlide.classList.contains('lookbook-product-slide')) {
                nextSlide = nextSlide.nextElementSibling;
            }
            if (nextSlide) {
                nextSlide.classList.add('active');
            } else {
                const allSlides = currentSlide.parentElement.querySelectorAll('.lookbook-product-slide');
                if (allSlides.length > 0) {
                    allSlides[0].classList.add('active');
                }
            }
        });
    });

    function updateCollectionButtonLandingVisibility() {
        const slides = document.querySelectorAll('.lookbook-product-slide');
        const landingButtons = document.querySelectorAll('.collection-button.landing');
        const anyActive = Array.from(slides).some(slide => slide.classList.contains('active'));
        landingButtons.forEach(landingButton => {
            if (anyActive) {
                landingButton.classList.add('hidden');
            } else {
                landingButton.classList.remove('hidden');
            }
        });
    }

    updateCollectionButtonLandingVisibility();

    document.querySelectorAll('.lookbook-product-slide').forEach(slide => {
        new MutationObserver(() => {
            updateCollectionButtonLandingVisibility();
        }).observe(slide, { attributes: true, attributeFilter: ['class'] });
    });


});
